module.exports = "//cdn-staging.livechat-static.com/webapp/img/favicon-unread-messages.svg?697275e933321e0174689b875a52830f";